module.exports = __webpack_public_path__ + "img/person.dbad4cb3.svg";